import React from "react";

// Import Table namespace from the main package
import { Table as DSTable } from "@packages/ds";

// Import types
import type {
  TableProps,
  TableTheadProps,
  TableTbodyProps,
  TableTrProps,
  TableTdProps,
  TableThProps,
  TableRowSize,
  SortDirections,
  SortState,
  SelectedValues
} from "@packages/ds";

// Create a wrapped Table component with console-specific enhancements if needed
const Table = (props: TableProps) => <DSTable {...props} />;

// Attach all subcomponents and hooks from the design system
Table.Table = Table;
Table.TableFlex = DSTable.TableFlex;
Table.Thead = DSTable.Thead;
Table.Tbody = DSTable.Tbody;
Table.Tr = DSTable.Tr;
Table.Td = DSTable.Td;
Table.Th = DSTable.Th;
Table.useHasScrolled = DSTable.useHasScrolled;
Table.useScrollPosition = DSTable.useScrollPosition;
Table.useSelect = DSTable.useSelect;
Table.useSort = DSTable.useSort;

// Extract the properties for re-export
const TableFlex = DSTable.TableFlex;
const Thead = DSTable.Thead;
const Tbody = DSTable.Tbody;
const Tr = DSTable.Tr;
const Td = DSTable.Td;
const Th = DSTable.Th;
const useHasScrolled = DSTable.useHasScrolled;
const useScrollPosition = DSTable.useScrollPosition;
const useSelect = DSTable.useSelect;
const useSort = DSTable.useSort;

// Re-export components via named exports for those who prefer that style
export {
  Table,
  TableFlex,
  Thead,
  Tbody,
  Tr,
  Td,
  Th,
  useHasScrolled,
  useScrollPosition,
  useSelect,
  useSort
};

// Re-export types
export type {
  TableProps,
  TableTheadProps,
  TableTbodyProps,
  TableTrProps,
  TableTdProps,
  TableThProps,
  TableRowSize,
  SortDirections,
  SortState,
  SelectedValues
};

// Default export
export default Table;
